import { css } from '@emotion/css';
import { SpaceSize } from 'src/styles';

export const spinnerHeight = css`
  height: ${SpaceSize.is128} !important;
`;
